import * as InteractionTypes from './types'

const initialState: InteractionTypes.IInteractionState = {
  path: undefined
}

export function interactionReducer(
  state = initialState,
  action: InteractionTypes.IInteractionActionTypes
): InteractionTypes.IInteractionState {
  switch(action.type){
    case InteractionTypes.ADD_INTERACTION:
      return {
        ...state,
        path: action.payload
      }
    case InteractionTypes.DELETE_INTERACTION:
      return {
        ...state,
        path: undefined
      }
    default:
      return {
        ...state
      }
  }
}
